import { dateFns } from '@lhb/func';
import { FC } from 'react';
import { useMethods } from '@lhb/hook';
import styles from '../index.module.less';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import V2DetailGroup from '@/common/components/Feedback/V2DetailItem/Group';

/**
 * @Description 沟通记录每一项
 */
const MeetCard:FC<{
  detail: any;
}> = ({
  detail
}) => {
  const communicationMethodName = detail?.communicationMethodName;
  const methods = useMethods({
    buildAssets(fileList) {
      if (Array.isArray(fileList) && fileList.length) {
        return fileList.map((item) => ({
          url: item,
          name: '',
        }));
      }
      return [];
    },
  });
  const assets = methods.buildAssets(detail?.fileList);
  return <div className={styles.meetCardCon}>
    <div className={styles.date}>
      {/* 日期 */}
      <div
        className={styles.dateTop}
      >{dateFns.getDateYearMonthDay(detail?.communicateAt)?.day}</div>
      {/* 年.月 */}
      <div
        className={styles.dateBottom}
      >{
          `${dateFns.getDateYearMonthDay(detail?.communicateAt)?.year}.${dateFns.getDateYearMonthDay(detail?.communicateAt)?.month}`
        }</div>
    </div>
    <div className={styles.record}>
      <div className={styles.title}>{detail?.name}{communicationMethodName ? `（${communicationMethodName}）` : ''}</div>
      <div className={styles.content}>{detail?.content}</div>
      {assets.length
        ? <V2DetailGroup moduleType='easy' className='mt-8 mb-6'>
          <V2DetailItem type='images' assets={assets} noStyle/>
        </V2DetailGroup>
        : <></>
      }
    </div>
  </div>;
};
export default MeetCard;
